export const actionButtonText = {
  CHECKIN: 'Check In',
  CHECKOUT: 'Check Out',
  REQUEST: 'Request',
  WITHDRAW: 'Withdraw',
}

export const searchQueryParam = 'searchText'
export const typeQueryParam = 'type'

export const locatStorageKeyPrefix = 'MY_RESOURCES_TABLE'
export const localStorageKey = {
  quickFilter: `${locatStorageKeyPrefix}_QUICK_FILTER`,
  groupByLabels: `${locatStorageKeyPrefix}_GROUP_BY_LABELS`,
}

export const availableProfilesTypeFilters = {
  FREQUENTLY_USED: 'frequently-used',
  FAVORITES: 'favorites',
}
